<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_service') : $t('labels.add_service') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full mb-4 p-0">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="service_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.service_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('service_name') }}</span>
            </div>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-service"
              button="submit"
            >{{ editRoute ? $t('labels.update_service') : $t('labels.add_service') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    if (this.editRoute) {
      this.getService();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateService();
        }
      });
    },
    // API Integration for add-update services
    async createUpdateService() {
      let input = {
        name: this.name
      };
      let url = this.editRoute
        ? "/services/update/" + this.editRoute
        : "/services/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-service",
        true
      );
      if (response) {
        this.$router.push({ name: "Services" });
      }
    },
    async getService() {
      let response = await this.getHTTPGetResponse(
        "/services/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let service = data.service;
        this.name = service.name;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>